<template>
  <div>
    <div class="h-100 w-100 modal-backdrop"></div>
    <div class="modal fade show" style="display: block;">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div v-if="!submitted && !submitting" class="modal-content">
          <div class="modal-header align-middle">
            <img src="../../assets/Logo5.png" /><h5 class="modal-title">Track My Referrals</h5>
            <router-link to="/" class="close">
              <span aria-hidden="true">×</span>
            </router-link>
          </div>
          <div class="modal-body request-invite">
            <div class="row">
              <div class="col-lg-6">
                <div class="form-group">
                  <input type="text" class="form-control" v-on:change="onReferralCodeChange" placeholder="Referral Code" v-bind:value="referralCode"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <input type="email" class="form-control" v-on:change="onEmailChange" placeholder="Email" v-bind:value="email"/>
                </div>
              </div>
            </div>
            <a class="btn btn-lg" v-on:click="trackMyReferrals" v-if="canSubmit">Track My Referrals</a>
            <a class="btn btn-lg btn-secondary" v-if="!canSubmit">Track My Referralss</a>
          </div>
        </div>
        <div v-if="!submitted && submitting" class="modal-content">
          <div class="modal-header">
            <img src="../../assets/Logo5.png" /><h5 class="modal-title">Track My Referrals</h5>
          </div>
          <div class="modal-body">
            <p>Loading . . .</p>
            <font-awesome-icon icon="sync-alt"></font-awesome-icon>
          </div>
        </div>

        <div v-if="submitted && !submitting && submissionError" class="modal-content">
          <div class="modal-header">
            <img src="../../assets/Logo5.png" /><h5 class="modal-title">Error Occurred</h5>
            <router-link to="/" class="close">
              <span aria-hidden="true">×</span>
            </router-link>
          </div>

          <div v-if="submissionError" class="modal-body">
            <p>Unknown error. Please try again later.</p>
          </div>
        </div>

        <div v-if="submitted && !submitting && !submissionError" class="modal-content">
          <div class="modal-header">
            <img src="../../assets/Logo5.png" /><h5 class="modal-title">Track My Referrals</h5>
            <router-link to="/" class="close">
              <span aria-hidden="true">×</span>
            </router-link>
          </div>

          <div class="modal-body">
            <h3 class="" v-if="submissionResponse.count > 0">You have <span class="text-success">{{submissionResponse.count}}</span> referral{{submissionResponse.count > 1 ? 's' : ''}}!</h3>
            <h3 class="" v-if="submissionResponse.count <= 0">You don't have any referrals yet!</h3>

            <hr />

            <div class="progress mx-5">
              <div class="progress-bar progress-bar-striped bg-success progress-bar-animated" role="progressbar" v-bind:style="`width: ${completedPercentage}%`" v-bind:aria-valuenow="completedPercentage" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div class="progress-goal text-right mb-5 text-primary">
              <div class="text-center">
                <h2><font-awesome-icon icon="arrow-up"></font-awesome-icon></h2>
                <p>Early Access!</p>
              </div>
            </div>

            <h4 class="mt-5 mb-5">Keep sharing to get early access!</h4>

            <div class="input-group">
              <input class="form-control" v-bind:value="submissionResponse.shareLink" readonly />
              <div class="input-group-append">
                <button class="btn" v-on:click="doCopy">Copy</button>
              </div>
            </div>

            <p class="text-center mt-3">Or</p>

            <a class="btn btn-success text-white" target="_blank" v-bind:href="submissionResponse.twitterLink">Twitter</a>
            <a class="btn btn-primary text-white" target="_blank" v-bind:href="submissionResponse.facebookLink">Facebook</a>
            <a class="btn btn-secondary text-dark" target="_blank" v-bind:href="submissionResponse.mailtoLink">Email</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {trackMyReferrals} from '../../api'
import {TweenLite} from 'gsap'

export default {
  name: 'TrackReferrals',
  mounted: function () {
    if (this.$route.params.code) {
      this.referralCode = this.$route.params.code
    }
  },
  data: function () {
    return {
      submitting: false,
      submitted: false,
      submissionResponse: false,
      submissionError: false,
      email: '',
      referralCode: '',
      completedPercentage: 0
    }
  },
  computed: {
    canSubmit: function () {
      if (this.submitting || this.submitted) {
        return false
      }

      if (!this.referralCode || !this.email) {
        return false
      }

      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(this.email).toLowerCase())
    }
  },
  methods: {
    trackMyReferrals: function () {
      this.submissionError = false

      trackMyReferrals(this.email, this.referralCode).then((response) => {
        this.submissionResponse = response
        this.submitted = true
        this.submitting = false

        window.localStorage.setItem('myUniqueCode', response.uniqueCode)
      }).catch(() => {
        this.submissionResponse = false
        this.submissionError = true
        this.submitted = false
        this.submitting = false
      })
    },
    doCopy: function () {
      this.$copyText(this.submissionResponse.shareLink).then(function (e) {}, function (e) {})
    },
    onEmailChange: function (e) {
      this.email = e.target.value
    },
    onReferralCodeChange: function (e) {
      this.referralCode = e.target.value
    }
  },
  watch: {
    submissionResponse: function (newValue) {
      TweenLite.to(this.$data, 2, {completedPercentage: (newValue.count > 10 ? 10 : newValue.count) * 10})
    }
  }
}
</script>

<style lang="scss" scoped>
  .request-invite .btn.btn-success {
    border: 2px solid #6752DD;
  }

  .progress-goal {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/TrackReferrals.vue